import { ProjectListItem, Project } from 'api/project';

type Inputs = (ProjectListItem | Project)[];
export const getFilteredProjects = (projects: Inputs, key = ''): Inputs =>
  key
    ? projects.filter((each) =>
        each?.projectName.toLowerCase().includes(key.toLowerCase()),
      )
    : projects;
